var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAwesomeList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15.438,
    viewBox: "0 0 19 15.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-list",
    "data-name": "Icon awesome-list",
    d: "M2.969,15.25H.594A.594.594,0,0,0,0,15.844v2.375a.594.594,0,0,0,.594.594H2.969a.594.594,0,0,0,.594-.594V15.844A.594.594,0,0,0,2.969,15.25Zm0-11.875H.594A.594.594,0,0,0,0,3.969V6.344a.594.594,0,0,0,.594.594H2.969a.594.594,0,0,0,.594-.594V3.969A.594.594,0,0,0,2.969,3.375Zm0,5.937H.594A.594.594,0,0,0,0,9.906v2.375a.594.594,0,0,0,.594.594H2.969a.594.594,0,0,0,.594-.594V9.906A.594.594,0,0,0,2.969,9.312Zm15.438,6.531H6.531a.594.594,0,0,0-.594.594v1.188a.594.594,0,0,0,.594.594H18.406A.594.594,0,0,0,19,17.625V16.438A.594.594,0,0,0,18.406,15.844Zm0-11.875H6.531a.594.594,0,0,0-.594.594V5.75a.594.594,0,0,0,.594.594H18.406A.594.594,0,0,0,19,5.75V4.562A.594.594,0,0,0,18.406,3.969Zm0,5.937H6.531a.594.594,0,0,0-.594.594v1.187a.594.594,0,0,0,.594.594H18.406A.594.594,0,0,0,19,11.687V10.5A.594.594,0,0,0,18.406,9.906Z",
    transform: "translate(0 -3.375)",
    fill: "#446fa2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeList);
export default __webpack_public_path__ + "static/media/icon-awesome-list.6d19364140053d43923a823379e2cad5.svg";
export { ForwardRef as ReactComponent };